// extracted by mini-css-extract-plugin
module.exports = {"dialogBody":"dialogBody__AJRm9","dialogFooter":"dialogFooter__LmZ0B","form":"form__n8nb3","tabList":"tabList__T7iXd","tabPanel":"tabPanel__-7jEI"};